import PropTypes from "prop-types";
import { useState } from "react";
import { Radio, RadioGroup, FormControlLabel } from "@mui/material";
import MDBox from "theme/components/MDBox";

function RadioButtonGroupField({ displayName, fieldRef, options }) {
  const [value, setValue] = useState("");

  return (
    <MDBox>
      <MDBox mb={1}>{displayName}</MDBox>

      <RadioGroup value={value} onChange={(e) => setValue(e.target.value)}>
        {options?.map((opt) => (
          <FormControlLabel
            key={opt.value}
            value={opt.value}
            control={<Radio />}
            label={opt.label}
          />
        ))}
      </RadioGroup>

      <input
        type="hidden"
        id={`dff_${fieldRef}`}
        name={fieldRef}
        value={value}
      />
    </MDBox>
  );
}

// Typechecking props
RadioButtonGroupField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object),
};

RadioButtonGroupField.defaultProps = {
  options: [],
};

export default RadioButtonGroupField;
